import { MAP_TYPES } from '@deck.gl/carto';

const SEARCHBOX_AUTOSUGGEST_SOURCE_ID = 'stateBroadbandSource';

function source(searchQuery = '', type = 'all', excludedTractCode = 0, year) {
  let stateNameCountyName = searchQuery.split(',').map((item) => item.trim());

  let whereClause = '';

  // If search query uses comma to search for county and state (matching e.g. "Autauga, Alabama").
  if (stateNameCountyName.length > 1) {
    whereClause =
      searchQuery &&
      `
        STARTS_WITH(CAST(tractcode AS string), "${excludedTractCode}") = FALSE AND
        (
          STARTS_WITH(tracts.countyname, INITCAP("${stateNameCountyName[0]}")) AND
          STARTS_WITH(tracts.statename, INITCAP("${stateNameCountyName[1]}"))
        ) AND
  `;
  } else {
    whereClause =
      searchQuery &&
      `
        STARTS_WITH(CAST(tractcode AS string), "${excludedTractCode}") = FALSE AND
        (
          STARTS_WITH(CAST(tractcode AS string), "${searchQuery}") OR
          STARTS_WITH(tracts.countyname, INITCAP("${searchQuery}")) OR
          STARTS_WITH(tracts.statename, INITCAP("${searchQuery}"))
        ) AND
  `;
  }

  let limitStates = searchQuery === '' || (type !== 'all' && type !== 'state') ? 0 : 5;
  let limitCounties = searchQuery === '' || (type !== 'all' && type !== 'county') ? 0 : 5;
  let limitTracts = searchQuery === '' || (type !== 'all' && type !== 'tract') ? 0 : 10;

  return {
    id: SEARCHBOX_AUTOSUGGEST_SOURCE_ID,
    type: MAP_TYPES.QUERY,
    connection: 'carto_dw',
    data: `
    (
        SELECT DISTINCT
          MAX(tracts.tractcode) AS tractcode,
          MAX(tracts.countyname) AS countyname,
          tracts.statename,
          MAX(tracts.geoid) AS geoid,
          'state' AS type,
          0 as sortkey,
          0 as lat,
          0 as lng
        FROM
          carto-dw-ac-cn5bemsi.shared.tracts tracts
        JOIN
          carto-dw-ac-cn5bemsi.shared.tract_geometries geometry ON tracts.geoid = geometry.geoid
        JOIN
          carto-dw-ac-cn5bemsi.shared.tract_observations AS observations ON tracts.geoid = observations.geoid
        WHERE ${whereClause} observations.year = ${year}
        GROUP BY
          tracts.statename
        LIMIT ${limitStates}
      )
      UNION ALL
      (
        SELECT DISTINCT
          MAX(tracts.tractcode) AS tractcode,
          tracts.countyname,
          tracts.statename,
          MAX(tracts.geoid) AS geoid,
          'county' AS type,
          1 as sortkey,
          0 as lat,
          0 as lng
        FROM
          carto-dw-ac-cn5bemsi.shared.tracts tracts
        JOIN
          carto-dw-ac-cn5bemsi.shared.tract_geometries geometry ON tracts.geoid = geometry.geoid
        JOIN
          carto-dw-ac-cn5bemsi.shared.tract_observations AS observations ON tracts.geoid = observations.geoid
        WHERE ${whereClause} observations.year = ${year}
        GROUP BY
          tracts.countyname, tracts.statename
        LIMIT ${limitCounties}
      )
      UNION ALL
      (
        SELECT
          tracts.tractcode,
          tracts.countyname,
          tracts.statename,
          tracts.geoid,
          'tract' AS type,
          2 as sortkey,
          ST_X(ST_CENTROID(geom)) AS lng,
          ST_Y(ST_CENTROID(geom)) AS lat
        FROM
          carto-dw-ac-cn5bemsi.shared.tracts tracts
        JOIN
          carto-dw-ac-cn5bemsi.shared.tract_geometries geometry ON tracts.geoid = geometry.geoid
        JOIN
          carto-dw-ac-cn5bemsi.shared.tract_observations AS observations ON tracts.geoid = observations.geoid
        WHERE ${whereClause} observations.year = ${year}
        LIMIT ${limitTracts}
      )
      ORDER BY
        sortkey
    `,
    queryParameters: {
      searchQuery,
      type,
      year,
    },
  };
}

export default source;
